import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

export default function Layout() {
  return (
    <div className="grain relative min-h-screen bg-stone">
      <ScrollToTop />
      <Nav />
      <main className="relative z-[2]">
        <Outlet />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}
